import React, { useState, useRef, useEffect } from 'react';
import './SliderSection.css';

function SliderSection({ 
    label, 
    fieldName, 
    value, 
    min = 0, 
    max = 100, 
    step = 1, 
    unit = '', 
    onChange, 
    icon,
    disabled = false,
    showValue = true,
    color = '#5C80BC',
    description
}) {
    const [isDragging, setIsDragging] = useState(false);
    const [displayValue, setDisplayValue] = useState(value);
    const sliderRef = useRef(null);

    useEffect(() => {
        setDisplayValue(value);
    }, [value]);

    const handleChange = (e) => {
        const newValue = parseInt(e.target.value);
        setDisplayValue(newValue);
        if (onChange) {
            onChange(fieldName, newValue);
        }
    };

    const handleMouseDown = () => {
        setIsDragging(true);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    // Calculate percentage for gradient background
    const percentage = ((displayValue - min) / (max - min)) * 100;

    return (
        <div className={`slider-section ${disabled ? 'disabled' : ''}`}>
            {/* Label Row */}
            <div className="slider-label-row">
                <label className="slider-label">
                    {icon && <img className="slider-icon" src={icon} alt="" />}
                    {label}
                    {showValue && (
                        <span className="slider-value">
                            {displayValue}{unit}
                        </span>
                    )}
                </label>
            </div>

            {/* Description */}
            {description && (
                <p className="slider-description">{description}</p>
            )}

            {/* Slider Container */}
            <div className="slider-container">
                {/* Min/Max Labels */}
                <div className="slider-range-labels">
                    <span className="range-label min">{min}{unit}</span>
                    <span className="range-label max">{max}{unit}</span>
                </div>

                {/* Slider Track */}
                <div className="slider-track-container">
                    <input
                        ref={sliderRef}
                        type="range"
                        name={fieldName}
                        min={min}
                        max={max}
                        step={step}
                        value={displayValue}
                        onChange={handleChange}
                        onMouseDown={handleMouseDown}
                        onMouseUp={handleMouseUp}
                        disabled={disabled}
                        className={`slider-input ${isDragging ? 'dragging' : ''}`}
                        style={{
                            '--slider-percentage': `${percentage}%`,
                            '--slider-color': color
                        }}
                    />
                    
                    {/* Custom Track Background */}
                    <div className="slider-track">
                        <div 
                            className="slider-progress"
                            style={{ 
                                width: `${percentage}%`,
                                backgroundColor: color
                            }}
                        />
                    </div>

                    {/* Custom Thumb */}
                    <div 
                        className={`slider-thumb ${isDragging ? 'dragging' : ''}`}
                        style={{ 
                            left: `${percentage}%`,
                            borderColor: color
                        }}
                    >
                        <div className="slider-thumb-inner" style={{ backgroundColor: color }} />
                    </div>
                </div>

                {/* Value Indicator */}
                <div className="slider-value-indicator">
                    <div 
                        className="value-tooltip"
                        style={{ 
                            left: `${percentage}%`,
                            opacity: isDragging ? 1 : 0
                        }}
                    >
                        {displayValue}{unit}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SliderSection;
